import axios from 'axios'
import initPolyfills from './polyfills'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'

export function initGlobals() {
  if (typeof window !== 'undefined') {
    initPolyfills()
    window['r2d2'] = r2d2
    window['cookie'] = cookie
    window['trackEvent'] = trackEvent
  }
}

function r2d2(in_: InR2D2) {
  const AuthURL = process.env.NEXT_PUBLIC_PLATFORM_AUTH_BASE_URL
  const url = `${AuthURL}/api/r2d2/`

  return axios.post(
    url,
    {
      app: 'KMS',
      ua: window?.navigator.userAgent,
      user: in_.user || cookie('user_id'),
      tracker: in_.tracker || cookie('trackerid'),
      ...in_,
      edata: {
        ...(in_.edata || {}),
        anonymousID: webengageAnonymousID(),
        ga_client_id: getGAClientID(),
        is_js: true,
        platform: window.innerWidth < 480 ? 'mweb' : 'web',
        web_engage: true,
        time: new Date().toString(),
      },
      odata: {
        ...(in_.odata || {}),
        url: window?.location.href,
      },
    },
    {
      withCredentials: true,
    }
  )
}

function getGAClientID() {
  try {
    return window['ga'].getAll()[0].get('clientId')
  } catch {
    return ''
  }
}

function webengageAnonymousID() {
  let aid = cookie('we_aid')
  if (aid !== undefined) return aid
  try {
    // @ts-ignore
    aid = window.webengage.user.getAnonymousId()
    cookie('we_aid', aid)
  } catch {
    aid = ''
  }
  return aid
}

export function cookie(key: string, value?: string) {
  if (typeof document === 'undefined') return
  if (typeof key === 'string' && typeof value === 'string') {
    document.cookie = `${key}=${value};path=/`
    return value
  }
  if (document.cookie.indexOf(`${key}=`) === -1) return
  return document.cookie.split(`${key}=`)[1].split(';')[0]
}
